import MU1 from "../../images/MaterialsUnlocked/mu1.png"
import MU2 from "../../images/MaterialsUnlocked/mu2.png"
import MU3 from "../../images/MaterialsUnlocked/mu3.png"
import MU4 from "../../images/MaterialsUnlocked/mu4.png"


export const MaterialsUnlocked23 = [
    {
        img : MU1,
        instagram : "https://www.instagram.com/p/Ch7QINAPt00/?igshid=YmMyMTA2M2Y="
    },
    {
        img : MU2,
        instagram : "https://www.instagram.com/p/Cjng5ORPwSw/?igshid=YmMyMTA2M2Y="
    },
    {
        img : MU3,
        instagram : "https://www.instagram.com/p/CkddWz_PUUm/?igshid=YmMyMTA2M2Y="
    },
    {
        img : MU4,
        instagram : "https://www.instagram.com/p/CmZAVuCPK8q/?igshid=YmMyMTA2M2Y="
    },
]